<template>
  <div style="position: relative;display: flex;align-items: center;justify-content: center;">
    <apexchart ref="chart" :type="type" :width="width" :height="height" :options="options" :series="series"></apexchart>
  </div>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import locales from '../../langs/apexChart/index.json'

export default {
  components: {
    'apexchart': () => import(/* webpackChunkName: "chunk_vue-apexcharts" */'vue-apexcharts')
  },
  mixins: [mixin, inputMixin],
  created() {
    if (this.options.chart) {
      this.options.chart.locales = locales
      this.options.chart.defaultLocale = this.locale
    }
  },
  beforeUpdate() {
    this.updateChart()
  },
  watch: {
    locale: function () {
      this.$refs.chart.setLocale(this.locale)
      this.updateChart()
    }
  },
  computed: {
    _chart() {
      return this.getDataSourceField(this.model.Chart) 
    },
    options() {
      return this._chart?.options
    },
    series() {
      return this._chart?.series
    },
    width() {
      return this._chart?.width
    },
    height() {
      return this._chart?.height
    },
    type() {
      return this._chart?.type
    },
    locale() {
      return this.$i18n.locale
    }
  },
  methods: {
    updateChart() {
      if (!this.$refs.chart) {
        return
      }
      if (this._chart.type == 'pie') {
        this.$refs.chart.updateOptions(this.options, false, true)
      }
      this.$refs.chart.updateSeries(this.series.map(r => r), false, true)
    }
  }  
}
</script>

<style>
</style>